import Link from 'next/link';
import React from 'react';
import Image from 'next/image';
import DropDownMenu from '../DropDownMenu';
import LoginForm from '../../../auth/LoginForm';
import { usePathname, useSearchParams } from 'next/navigation';

type LoginLinkProps = {
	active: boolean;
	className?: string;
	isLoading: boolean;
	onClick: () => void;
	onClose: () => void;
	backIcon?: string;
};

export default function LoginLink(props: LoginLinkProps) {
	const { active, className, isLoading, onClick, onClose, backIcon } = props;
	const pathname = usePathname();
	const searchParams = useSearchParams();

	const currentSearchParams = searchParams.toString();
	const fullUrl = pathname + (currentSearchParams ? `?${currentSearchParams}` : '');

	return (
		<DropDownMenu
			className={`login-link ${className}`}
			active={active}
			onToggle={onClick}
			header={
				<>
					<Image
						src="/images/icons/login.svg"
						width={20}
						height={20}
						alt="login-icon"
						className="mobile-only"
					/>
					<span>{isLoading ? 'Loading...' : 'login'}</span>
				</>
			}
		>
			<LoginForm onClose={onClose} redirectUrl={fullUrl} backIcon={backIcon}>
				<Link className="forgot-password" href="/forgot-password" onClick={onClose}>
					Forgot password
				</Link>
			</LoginForm>
		</DropDownMenu>
	);
}
